export class CarouselItem {
    isSelected: boolean;
    nroEmpresa: string;
    nroContribuyente: string;
    aportacion: string;

    constructor(nroEmpresa: string, nroContribuyente: string, aportacion: string, isSelected:boolean) {
        this.nroEmpresa = nroEmpresa;
        this.nroContribuyente = nroContribuyente;
        this.aportacion = aportacion;
        this.isSelected=isSelected;

    }

}